import CurriculumSubscriptionOrderConfirmationCard from "@pathwright/features/src/modules/order/CurriculumSubscriptionOrderConfirmationCard"
import GiftSubscriptionOrderConfirmationCard, {
  GiftSubscriptionConfirmationCard
} from "@pathwright/features/src/modules/order/GiftSubscriptionOrderConfirmationCard"
import OrderConfirmationContainer from "@pathwright/features/src/modules/order/OrderConfirmationContainer"
import OrderCurriculumSubscriptionCard from "@pathwright/features/src/modules/order/OrderCurriculumSubscriptionCard"
import OrderGiftSubscriptionCard from "@pathwright/features/src/modules/order/OrderGiftSubscriptionCard"
import OrderSubscriptionCard from "@pathwright/features/src/modules/order/OrderSubscriptionCard"
import SubscriptionOrderConfirmationCard, {
  SubscriptionRedeemptionConfirmationCard
} from "@pathwright/features/src/modules/order/SubscriptionOrderConfirmationCard"
import { getParam } from "@pathwright/features/src/modules/utils/urls"
import { createCardRoutes } from "lib/core/routing/card-routing"
import StoreOrLibraryBrowse from "store/StoreOrLibraryBrowse"
import {
  getOrderId,
  getPrefixedOrderConfirmationPaths,
  orderConfirmationPaths
} from "./order-confirmation-routes"

// when licensee school licenses through licensor store
export const curriculumLicenseeLicenseRoute = createCardRoutes(
  `/library/store/:schoolId(\\d+)/:resourceId(\\d+)/:licenseOfferingId(\\d+)/`,
  {
    success: {
      path: orderConfirmationPaths,
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, match, location }) => (
        <OrderConfirmationContainer
          card={card}
          orderId={getOrderId({ match, location })}
        />
      )
    }
  },
  StoreOrLibraryBrowse
)

export const subscriptionRoute = createCardRoutes(
  "/",
  {
    checkout: {
      path: "subscribe/",
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, location }) => {
        const { plans, products, vc } = getParam(location.search)
        const vcFilter = getParam(location.search, /vc_(?<vc>.+)/)

        function getIds(idsStr) {
          return idsStr
            ? idsStr.split(",").map((id) => parseInt(id))
            : undefined
        }

        const planIds = getIds(plans)
        const productIds = getIds(products)

        return (
          <OrderSubscriptionCard
            card={card}
            planIds={planIds}
            productIds={productIds}
            visibilityCode={vc}
            visibilityCodeFilter={vcFilter}
          />
        )
      }
    },
    checkoutSuccess: {
      path: getPrefixedOrderConfirmationPaths("subscribe/"),
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, match, location }) => (
        <SubscriptionOrderConfirmationCard
          card={card}
          orderId={getOrderId({ match, location })}
        />
      )
    },
    redeemSuccess: {
      path: "subscribe/thank-you/",
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, match }) => (
        <SubscriptionRedeemptionConfirmationCard card={card} />
      )
    }
  },
  StoreOrLibraryBrowse
)

export const giftSubscriptionRoute = createCardRoutes(
  "/",
  {
    checkout: {
      path: "gift-subscription/",
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, location }) =>
        getParam(location.search).gc ? (
          <GiftSubscriptionConfirmationCard
            card={card}
            code={getParam(location.search).gc}
          />
        ) : (
          <OrderGiftSubscriptionCard
            card={card}
            visibilityCode={getParam(location.search).vc}
            visibilityCodeFilter={getParam(location.search, /vc_(?<vc>.+)/)}
          />
        )
    },
    success: {
      path: getPrefixedOrderConfirmationPaths("gift-subscription/"),
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, match, location }) => (
        <GiftSubscriptionOrderConfirmationCard
          card={card}
          orderId={getOrderId({ match, location })}
        />
      )
    }
  },
  StoreOrLibraryBrowse
)

export const curriculumSubscriptionRoute = createCardRoutes(
  "/",
  {
    checkout: {
      path: "school-licensing/signup/",
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, location }) => (
        <OrderCurriculumSubscriptionCard
          card={card}
          visibilityCode={getParam(location.search).vc}
          visibilityCodeFilter={getParam(location.search, /vc_(?<vc>.+)/)}
        />
      )
    },
    success: {
      path: getPrefixedOrderConfirmationPaths("school-licensing/signup/"),
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card, match, location }) => (
        <CurriculumSubscriptionOrderConfirmationCard
          card={card}
          orderId={getOrderId({ match, location })}
        />
      )
    }
  },
  StoreOrLibraryBrowse
)
